





























































































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { HOST, API_URL } from "../global";
import { LOGIN } from "../store/actions.names";
//import { TOGGLE_LOGIN } from "../store/mutations.names";
import axios from "axios";
import { IS_LOGGED_IN } from "../store/getters.names";

@Component({
  name: "Login"
})
export default class Login extends Vue {
  loginForm: any = {
    username: "",
    email: "",
    password: ""
  };

  @Getter(IS_LOGGED_IN) isLoggedIn!: boolean;
  //@Mutation(TOGGLE_LOGIN) [TOGGLE_LOGIN] : any;
  @Action(LOGIN) login: any;

  public loginUser() {
    let tc: any = this;
    tc[LOGIN](this.loginForm).then(() => {
      this.$router.push("/dashboard");
    });
  }

  @Watch("isLoggedIn", { immediate: true })
  handleLogIn(val: boolean, oldVal: boolean) {
    if (val) {
      // console.log(val);
      this.$router.push("/dashboard");
    }
  }
}
